/* eslint-disable indent */
function pageTitle($transitions, $timeout, languageProvider, $translate) {
  return {
    restrict: 'A',
    replace: true,
    link(scope, element) {
      const updatePageTitle = (transition) => {
        $timeout(() => {
          const lang = languageProvider.language;
          const localePageTitle =
            typeof transition.to().data.pageTitle === 'string'
              ? $translate
                  .instant(transition.to().data.pageTitle)
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')
              : transition.to().data.pageTitle[lang];
          const titlePrefix =
            transition.to().data &&
            transition.to().data.pageTitle &&
            localePageTitle
              ? `${localePageTitle} | `
              : '';
          element.html(`${titlePrefix}WebSked | Arc`);
        });
      };

      $transitions.onSuccess({}, updatePageTitle);
    }
  };
}

const directiveArray = [
  '$transitions',
  '$timeout',
  'languageProvider',
  '$translate',
  pageTitle
];

export default function (ngModule) {
  ngModule.directive('pageTitle', directiveArray);
}
